import { render, staticRenderFns } from "./ManOfSciResPerInFill.vue?vue&type=template&id=63cfa2ee&scoped=true&"
import script from "./ManOfSciResPerInFill.vue?vue&type=script&lang=js&"
export * from "./ManOfSciResPerInFill.vue?vue&type=script&lang=js&"
import style0 from "./ManOfSciResPerInFill.vue?vue&type=style&index=0&id=63cfa2ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cfa2ee",
  null
  
)

export default component.exports